import { Immutable } from "immer";
import React from "react";
import { jt, t } from "ttag";

import { templates } from "@reactivated";

import { AccountContentTitle } from "../AccountContentTitle";
import { SideNav } from "../SideNav";

type IProps = Immutable<templates.ProfileDocumentTemplate>;

export const ProfileBody = (props: IProps): React.JSX.Element => {
    const {
        has_nav,
        side_nav,
        content_title,
        phone_display,
        phone_href,
        full_name,
        email,
        profile_fields,
        date_registered,
        is_sso,
        has_password,
        sso_message,
        change_password_url,
        profile_update_url,
        register_url,
        addresses,
        address_list_url,
        logout_url,
    } = props;
    return (
        <div className="l-capped-width u-margin-bottom--xl u-full-width-title">
            {has_nav && (
                <div className="l-side-nav">
                    <SideNav items={side_nav} />
                </div>
            )}

            <div className="l-side-nav-content">
                <AccountContentTitle
                    contentTitle={content_title}
                    phoneDisplay={phone_display}
                    phoneHref={phone_href}
                />

                <div className="content__copy--full-width">
                    <table className="account-table account-table--info">
                        <tbody>
                            <tr>
                                <th className="account-table__header">{t`Name`}</th>
                                <td>{full_name}</td>
                            </tr>
                            <tr>
                                <th className="account-table__header">
                                    {t`Email address`}
                                </th>
                                <td>{email}</td>
                            </tr>
                            {profile_fields.map((field, i) => (
                                <tr key={i}>
                                    <th className="account-table__header">
                                        {field.name}
                                    </th>
                                    <td>{field.value}</td>
                                </tr>
                            ))}
                            <tr>
                                <th className="account-table__header">
                                    {t`Date registered`}
                                </th>
                                <td>{date_registered}</td>
                            </tr>
                        </tbody>
                    </table>
                    {is_sso ? (
                        <p>{sso_message}</p>
                    ) : has_password ? (
                        <>
                            <div className="account-profile-link">
                                <a className="link" href={change_password_url}>
                                    {t`Change password`}
                                </a>
                            </div>
                            <div className="account-profile-link">
                                <a className="link" href={profile_update_url}>
                                    {t`Edit profile info`}
                                </a>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="account-profile-link">
                                <a className="link" href={register_url}>
                                    {t`Create password`}
                                </a>
                            </div>
                            <div className="account-profile-link">
                                <a className="link" href={profile_update_url}>
                                    {t`Edit profile info`}
                                </a>
                            </div>
                        </>
                    )}

                    {addresses.length > 0 && (
                        <table className="account-table account-table--addresses">
                            <tbody>
                                {addresses.map((address, i) => {
                                    const addressNumber = i + 1;
                                    return (
                                        <tr key={i}>
                                            <th
                                                style={{ verticalAlign: "top" }}
                                                className="account-table__header"
                                            >
                                                {jt`Address #${addressNumber}`}
                                                {address.is_default_for_shipping && (
                                                    <>
                                                        <br />
                                                        <span className="label label-success">
                                                            {
                                                                address.default_shipping_label
                                                            }
                                                        </span>
                                                    </>
                                                )}
                                                {address.is_default_for_billing && (
                                                    <>
                                                        <br />
                                                        <span className="label label-info">
                                                            {
                                                                address.default_billing_label
                                                            }
                                                        </span>
                                                    </>
                                                )}
                                            </th>
                                            <td>
                                                {address.name}
                                                <br />
                                                {address.line1}
                                                <br />
                                                {address.line2 && (
                                                    <>
                                                        {address.line2}
                                                        <br />
                                                    </>
                                                )}
                                                {address.line3 && (
                                                    <>
                                                        {address.line3}
                                                        <br />
                                                    </>
                                                )}
                                                {address.city}
                                                <br />
                                                {address.state}
                                                <br />
                                                {address.postcode}
                                                <br />
                                                {address.country}
                                                <br />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                    <div className="account-profile-link">
                        <a className="link" href={address_list_url}>
                            {t`Manage address(es)`}
                        </a>
                    </div>
                    <div className="account-profile-link">
                        <a className="link" href={logout_url}>
                            {t`Logout`}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};
